// src/components/modules/information.js

import React, { useState } from 'react';

const Information = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVisibility = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div class={isExpanded ? 'container-expanded' : 'container'}>
      <button className={isExpanded ? 'expand-btn expanded' : 'expand-btn'} onClick={toggleVisibility}>
        {isExpanded ? 'Information' : 'Information'}
      </button>
      {isExpanded && (
        <ul>
          <li><a translate="no" href="https://chat.openai.com" target="_blank" rel="noopener noreferrer">ChatGPT</a></li>
          <li><a translate="no" href="https://www.google.com" target="_blank" rel="noopener noreferrer">Google</a></li>
          <li><a translate="no" href="https://www.bing.com" target="_blank" rel="noopener noreferrer">Bing</a></li>
          <li><a translate="no" href="https://www.wikipedia.com" target="_blank" rel="noopener noreferrer">Wikipedia</a></li>
          <li><a translate="no" href="https://www.britannica.com" target="_blank" rel="noopener noreferrer">Britannica</a></li>
          <li><a translate="no" href="https://www.nationalgeographic.com" target="_blank" rel="noopener noreferrer">National Geographic</a></li>
          <li><a translate="no" href="https://www.howstuffworks.com" target="_blank" rel="noopener noreferrer">How Stuff Works</a></li>
          <li><a translate="no" href="https://www.webmd.com" target="_blank" rel="noopener noreferrer">Web MD</a></li>
          <li><a translate="no" href="https://www.nasa.gov" target="_blank" rel="noopener noreferrer">NASA</a></li>
          <li><a translate="no" href="https://www.history.com" target="_blank" rel="noopener noreferrer">History</a></li>
        </ul>
      )}
    </div>
  );
}

export default Information;